export const SET_LOADING = 'src/store/payments/SET_LOADING'
export const SET_PAYMENTS = 'src/store/payments/SET_PAYMENTS'
export const SET_GATEWAYS = 'src/store/payments/SET_GATEWAYS'
